import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import FormattedCurrencyContainer from '../../../components/formatted-currency/container';
import style from './currency-column.module.less';

const CurrencyColumn = ({ currencyCode, value, overideStyle = false }) => {
  return (
    <div
      className={classnames({
        [style['currency-column-value']]: !overideStyle,
      })}
    >
      <FormattedCurrencyContainer currencyCode={currencyCode} value={value} />
    </div>
  );
};

CurrencyColumn.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  overideStyle: PropTypes.bool,
};

export default React.memo(CurrencyColumn);
